import React from "react";

const ResetFilters = ({title, classname, onClick, font="font-itcmedium", borderColor="border-[#E5E7EB]", textColor="text-[#1F2A37]"}) => {
    return(
        <button onClick={onClick} className={`flex ${classname} h-[40px] leading-none items-center cursor-pointer border-[1px] ${borderColor}  rounded-lg justify-center px-4 p-2`}>
            <p className={`${font} text-[14px] ${textColor}`}>Reiniciar filtros</p>
        </button>

    );
};

export default ResetFilters;